<template>
  <ConfirmationModal
    bodyText=""
    :handleCancel="handleCancel"
    :handleContinue="handleContinue"
    headerText="Enable Custom Permissions"
  >
    <p>
      Access and permissions on this
      {{ deviceItemLabel }}
      are provided by membership in the user group(s):
      <strong>{{ userGroupNames }}.</strong>
      <br>
      <br>
      Click
      <strong>continue</strong>
      to override the current permission level and add a direct binding between
      <strong>{{ userName }}</strong>
      and
      <strong>{{ systemName }}</strong>.
    </p>
  </ConfirmationModal>
</template>

<script>
import ConfirmationModal from 'components/Modal/ModalComponents/ConfirmationModal.vue';
import ModalEventBus from 'client/components/Modal/ModalEventBus';

export default {
  name: 'SudoStatusDirectBindingConfirmationModalBody',

  components: {
    ConfirmationModal,
  },

  props: {
    deviceItemLabel: {
      type: String,
      required: true,
    },
    handleCancel: {
      type: Function,
      default: () => ModalEventBus.close(),
    },
    handleContinue: {
      type: Function,
      default: () => ModalEventBus.close(),
    },
    systemName: {
      type: String,
      required: true,
    },
    userGroupNames: {
      type: String,
      required: true,
    },
    userName: {
      type: String,
      required: true,
    },
  },
};
</script>
